import { ComponentSingleStyleConfig } from "@chakra-ui/react";
import { focusRing, focusRingInvalid } from "../focusStyles";

/**
 * Input is a multipart component.
 * To set the theme correctly, you must override each variant individually.
 * You can't use the baseStyle, as it will just get overwritten by the
 * more specific styling in each variant.
 */
export const inputTheme: ComponentSingleStyleConfig = {
  variants: {
    outline: {
      field: {
        borderColor: "gray.300",

        borderRadius: "md",
        _hover: {
          borderColor: "gray.400",
        },
        _focus: {
          borderColor: "gray.700",
          ...focusRing,
        },

        // error state on a form
        _invalid: {
          borderColor: "error.500",
          boxShadow: "none",
          _hover: {
            borderColor: "error.500",
          },
          _focus: {
            borderColor: "error.500",
            ...focusRingInvalid,
          },
        },
      },
    },
  },
};
